import type { HistoryMessageItem, IMFile, MessageIncomingEvent, MessageOutgoingEvent } from '@wui/im'

import { isRtfFile, resolveAttachmentContentKind } from './file-type-utils'

type ChatAttachmentEvent = HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent>

export const getEventAttachmentFiles = (
  event: ChatAttachmentEvent,
  filecookie: string,
): IMFile[] | undefined => {
  const forwardingFiles = event.item.forwarding?.forwardingFiles
  if (forwardingFiles?.some(file => file.filecookie === filecookie)) {
    return forwardingFiles
  }
  return event.item.files
}

export const getViewableFiles = (files: IMFile[] | undefined): IMFile[] => {
  if (!files?.length) {
    return []
  }
  return files.filter((file) => {
    if (isRtfFile(file)) {
      return false
    }
    return resolveAttachmentContentKind(file) !== null
  })
}
